import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Card, Col, Row } from 'react-bootstrap'
import HistogramaVolcadoras from '../../../Productividad/containers/histogramas/HistogramaVolcadoras'
import HistogramaCaladoPorPuesto from '../../../Productividad/containers/histogramas/HistogramaCaladoPorPuesto'
import { actualizarHistogramasCDMD } from '../../../Productividad/actions/HistogramaActions'
import HistogramaIngreso from '../../../Productividad/containers/histogramas/HistogramaIngreso'
import { INTERVALO_ACTUALIZACION } from '../../../../config/settings'

function Histogramas (props) {
  const { actualizarHistogramasCDMD } = props

  useEffect(() => {
    actualizarHistogramasCDMD(new Date(), new Date())

    const interval = setInterval(() => {
      actualizarHistogramasCDMD(new Date(), new Date())
      console.log('actualizo histgramas')
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [actualizarHistogramasCDMD])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '1% 0' }}>
      <Card className='shadow rounded' >
        <Row style={{ alignItems: 'center' }}>
          <Col md={4}><HistogramaIngreso /></Col>
          <Col md={4}><HistogramaCaladoPorPuesto /></Col>
          <Col md={4}><HistogramaVolcadoras showCalendar={false} /></Col>
        </Row>
      </Card>
    </div>
  )
}

const mapActionsToProps = {
  actualizarHistogramasCDMD
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(Histogramas)
